import { CaseLineModel } from '@onrunning/backstage-models';

export class CaseLine extends CaseLineModel {
  public collapsed: boolean;
}
